import { Config } from '@genial/config';
import * as NB from 'native-base';

import { useToken } from '../../store/token/hooks';
import { Template } from '../../templates';

export const NotFound = () => {
  const { token } = useToken();

  const handleReloadWindow = () => {
    window.open(`${Config.OriginUrlApp}/app/boleta-facil`, '_top');
  };

  const tokenInvalidMessage = {
    title: 'Acesso inválido.',
    description:
      'Não foi possível recuperar informações de seu acesso ou permissão, tente novamente.',
    onPress: handleReloadWindow,
  };

  const tokenExpiredMessage = {
    title: 'Acesso expirado.',
    description: 'A duração seu acesso excedeu o tempo limite, será necessário refazer o processo.',
    onPress: handleReloadWindow,
  };

  return (
    <NB.VStack alignSelf={'center'}>
      <Template.NotFound
        {...(token.isExpired && tokenExpiredMessage)}
        {...(!token.isValid && tokenInvalidMessage)}
      />
    </NB.VStack>
  );
};
